import ContactsList from 'containers/ContactList'

export default ContactsList
